import { Modal } from "antd";
import React from "react";
import { MyModal } from "../../../../components/styled-components";

interface MyModalProps {
  visible: boolean;
  onClose: () => void;
  onMatch: () => void;
  batchID?: string;
  trackingNo?: string;
  orderNo?: string;
}

const ConfirmNoFileModal: React.FC<MyModalProps> = ({ visible, onClose, onMatch }) => {
  const confirmClose = () => {
    Modal.confirm({
      title: "ต้องการปิดหน้าต่างนี้ไหม",
      content: "order นี้จะไม่ถูกแพ็ค!!",
      onOk() {
        onClose();
      },
      onCancel() {
        console.log("Cancel close");
      },
    });
  };
  return (
    <MyModal
      title="กรุณายืนยันเพื่อทำการ pack... !!"
      visible={visible}
      onOk={() => {
        onMatch();
      }}
      onCancel={() => confirmClose()}
      okText="OK"
      cancelText="Cancel"
    >
      <p>Are you sure you want to pack this order without a packing slip?</p>
    </MyModal>
  );
};

export default ConfirmNoFileModal;
